import { ComponentProps, FC, useMemo } from 'react';
import ReactMarkdown, { defaultUrlTransform } from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkDirective from 'remark-directive';

import { Markdown } from './Markdown';
import { MarkdownLink } from './MarkdownLink';
import { Blockquote, Quote } from './Quote';
import { customDirective } from './customDirective';

const remarkPlugins = [remarkDirective, customDirective];
const rehypePlugins = [rehypeRaw];

/** @deprecated Please use the non-legacy version of this component if no HTML is passed through your markdown */
export const MarkdownLegacy: FC<ComponentProps<typeof Markdown>> = ({ components, children }) => (
  <ReactMarkdown
    remarkPlugins={remarkPlugins}
    rehypePlugins={rehypePlugins}
    urlTransform={(url) => (url.startsWith('tel:') ? url : defaultUrlTransform(url))}
    components={useMemo(
      () => ({
        a: MarkdownLink,
        quote: Quote,
        blockquote: Blockquote,
        ...components,
      }),
      [components],
    )}
  >
    {children}
  </ReactMarkdown>
);
